import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const TopbarRoot = styled('header')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
}))

export const Container = styled(Box)(({ theme }) => ({
  maxWidth: 1100,
  margin: '0 auto',
  padding: theme.spacing(1, 2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}))

export const LogoImg = styled('img')(({ theme }) => ({
  display: 'block',
  height: 'auto',
}))

export const DesktopNav = styled('nav')(({ theme }) => ({
  marginLeft: 'auto',
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'block',
  },
}))

export const NavList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  display: 'flex',
  gap: theme.spacing(3),
  margin: 0,
  padding: 0,
}))

export const NavLink = styled('a')(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: 600,
  color: theme.palette.text.primary,
  textDecoration: 'none',
  padding: theme.spacing(1, 0),
  '&:hover': { color: theme.palette.primary.main },
}))

export const Actions = styled('div')(({ theme }) => ({
  display: 'none',
  marginLeft: theme.spacing(2),
  gap: theme.spacing(1),
  [theme.breakpoints.up('lg')]: {
    display: 'inline-flex',
  },
}))

export const BurgerBtn = styled('button')(({ theme }) => ({
  marginLeft: 'auto',
  width: 36,
  height: 30,
  border: 'none',
  background: 'transparent',
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
  '& span': {
    width: '100%',
    height: 2,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 1,
  },
}))

export const MobileMenu = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up('lg')]: {
    display: 'none !important',
  },
}))

export const MobileLink = styled('a')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  textDecoration: 'none',
}))
